<template>
  <v-card class="ma-3" outlined>

    <v-card-text class="pa-2">
      <v-row no-gutters>
        <v-col cols="12" sm="6" md="3">
          <im-sheet-interval-filter
            :from.sync="c_from"
            :until.sync="c_until"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <im-sheet-contract-filter
            :contract.sync="c_contract"
          />
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <im-sheet-rate-type-filter
            :types.sync="c_types"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
  export default {

    components: {
      'im-sheet-interval-filter':  () => import('@/components/Sheet/Filters/SheetIntervalFilter'),
      'im-sheet-contract-filter':  () => import('@/components/Sheet/Filters/SheetContractFilter'),
      'im-sheet-rate-type-filter': () => import('@/components/Sheet/Filters/SheetRateTypeFilter')
    },

    props: {
      from: null,
      until: null,
      contract: null,
      types: Array
    },

    computed: {
      c_from: {
        get() { return this.from; },
        set(val) { this.$emit("update:from", val) }
      },
      c_until: {
        get() { return this.until; },
        set(val) { this.$emit("update:until", val) }
      },
      c_contract: {
        get() { return this.contract; },
        set(val) { this.$emit("update:contract", val) }
      },
      c_types: {
        get() { return this.types; },
        set(val) { this.$emit("update:types", val) }
      }
    }

  }
</script>